import React, { useEffect } from "react"
import { NavLink } from "react-router-dom"

import { Input, Button } from "antd"

import { useDispatch, useSelector } from "react-redux"
import { userLoginAction, clearUserLoginError } from "../../redux/actions/userActions"

import * as yup from "yup"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"

import { useState } from "react"
import LoginWithLandline from "./LoginWithLandline"
import { EyeInvisibleOutlined, EyeOutlined, LockFilled } from "@ant-design/icons"
import { FaUserAlt } from "react-icons/fa"
import { Mixpanel } from "../../utils/mixpanel"
import LoginAttemptsMsg from "./LoginAttemptsMsg"
import FloatInput from "../../utils/FloatInput/FloatInput"

const schema = yup
  .object({
    credential: yup.string().required("Enter a Valid Email or Phone Number"),
    password: yup.string().required("Enter Valid Password")
  })
  .required()

const LoginComponent = ({ userName }) => {
  const defaultValues = {
    credential: userName || "",
    password: ""
  }

  const dispatch = useDispatch()
  const [showLandline, setShowLandline] = useState(false)
  const [disableLogin, setDisableLogin] = useState(false)

  const { loading: authorizeLoading, error: authorizeErr } = useSelector(state => state.userInfo)

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema)
  })

  const onSubmit = async ({ credential, password }) => {
    await dispatch(userLoginAction(credential, password))
  }

  useEffect(() => {
    if (authorizeErr) setValue("password", "")
  }, [authorizeErr])

  return (
    <>
      <LoginAttemptsMsg setDisableLogin={setDisableLogin} />
      {showLandline ? (
        <LoginWithLandline
          setShowLandline={setShowLandline}
          disableLogin={disableLogin}
          setDisableLogin={setDisableLogin}
        />
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <Controller
              name="credential"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Input
                  size="large"
                  prefix={<FaUserAlt size={15} />}
                  status={errors.credential ? "error" : undefined}
                  {...field}
                  disabled={true}
                />
              )}
            />

            {errors.credential ? (
              <small className="text-danger">{errors.credential.message}</small>
            ) : null}
          </div>
          <div className="mb-3">
            <p
              className="text-center text-secondary"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShowLandline(true)
                dispatch(clearUserLoginError())
                setDisableLogin(false)
              }}>
              Login with landline
            </p>
          </div>

          <div className="min-h-[65px]">
            <Controller
              name="password"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <FloatInput label="Password">
                  <Input.Password
                    size="large"
                    prefix={<LockFilled className="text-[#666B78]" size={15} />}
                    status={errors.password ? "error" : undefined}
                    {...field}
                    onChange={e => field.onChange(e?.target?.value?.replace(/\s/g, ""))}
                    iconRender={visible => (visible ? <EyeInvisibleOutlined /> : <EyeOutlined />)}
                    disabled={disableLogin}
                  />
                </FloatInput>
              )}
            />
            {errors.password ? (
              <small className="text-danger">{errors.password.message}</small>
            ) : null}
          </div>

          <NavLink
            to="/forgot-password"
            className="mb-3 text-primary float-end px-0 no-underline"
            onClick={() => Mixpanel.track("Forgot Password Clicked")}>
            Forgot Password?
          </NavLink>

          <Button
            block
            size="large"
            type="primary"
            htmlType="submit"
            loading={authorizeLoading}
            disabled={disableLogin}
            onClick={() => {
              Mixpanel.track("Login Clicked", { Email: userName })
            }}>
            Login
          </Button>

          {authorizeErr !== undefined && typeof authorizeErr === "string" && (
            <p className="mt-3 text-danger text-center font-medium">{authorizeErr}</p>
          )}
        </form>
      )}
    </>
  )
}

export default LoginComponent
